/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
    GraphQLSchema as Schema,
    GraphQLObjectType as ObjectType,
} from 'graphql';

import content from './queries/content';
import services from './queries/services';
import realisations from './queries/realisations';
import posts from './queries/posts';
import slogans from './queries/slogans';
import footer from './queries/footer';
import accueil from './queries/accueil';
import contact from './queries/contact';
import approche from './queries/approche';
import agence from './queries/agence';
import categories from './queries/categories';
import promotions from './queries/promotions';
import social from './queries/social';
import formContact from './queries/formContact';
import strategieWeb from './queries/strategieWeb';
import serviceConseil from './queries/serviceConseil';
import developpementWeb from './queries/developpementWeb';


const schema = new Schema({
    query: new ObjectType({
        name: 'Query',
        fields: {
            posts,
            services,
            realisations,
            slogans,
            footer,
            accueil,
            agence,
            contact,
            categories,
            promotions,
            social,
            approche,
            formContact,
            strategieWeb,
            serviceConseil,
            developpementWeb,
        },
    }),
});

export default schema;



// WEBPACK FOOTER //
// ./data/schema.js